import { useLayoutEffect } from "react";

import { PageHeaderConfig } from "../PageHeaderProvider";
import { usePageHeaderContext } from "./usePageHeaderContext";

export const useSetPageHeader = (
  config: PageHeaderConfig,
  deps: readonly unknown[],
): void => {
  const { setConfig } = usePageHeaderContext();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    setConfig(config);

    return () => setConfig({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
